export type SupportedLocale = 'en' | 'fr' | 'it';

export const SUPPORTED_LOCALES: { [key: string]: SupportedLocale } = {
  EN: 'en',
  FR: 'fr',
  IT: 'it',
};

export const SUPPORTED_LOCALES_STRINGS: SupportedLocale[] = ['en', 'fr', 'it'];
